<template>
  <div class="ad-modal-backdrop">
    <div id="ad_modal" class="ad-modal">
      <div class="ad-scrollbox is-centered has-text-centered">
        <span class="is-size-3 is-pulled-right has-text-right btn-close"><a @click="close"><i class="fas fa-times-circle"></i></a></span>

        <div class="add-info-box">
          <div v-show="!enableSubmission">
            <p>Your scorecard will be submitted after this short video.</p>
          </div>
          <div v-show="enableSubmission">
            <p><a @click="submitScoreCard">Click here to continue</a></p>
          </div>
        </div>

        <video controls id="ad_video" class="adVideo" @ended="onEnd()">
          <source :src="`${publicPath}video/axes2-video-short.mp4`" type="video/mp4">
          Your browser does not support the video tag.  
            <p><a @click="submitScoreCard">Click here to submit your scorecard.</a></p>
        </video>

      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.add-info-box {
  padding-bottom: 20px;
}
.ad-modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: black;
  display: flex;
  justify-content: center;
  align-items: center;
  z-Index: 1000;
}
.ad-modal {
  font-family: Verdana;
  padding: 5px;
  border-radius: 25px !important;
  background-color: black;
  box-shadow: 2px 2px 20px 1px;
  display: flex;
  flex-direction: column;
  width: 95%;
  height: 95%;
}
.ad-scrollbox {
  width: 100%;
  height: 100%;
  padding: 20px;
}
.btn-close {
  font-size: 2em;
  padding-left: 10px;
  cursor: pointer;
  font-weight: bold;
  text-align: right;
}
.adVideo {
  /*border: solid yellow 2px;*/
  border-radius: 25px;
  width: 95%;
}

@media screen and (min-width: 600px) {
  .adVideo {
    width: 65%;
  }
}
</style>

<script>
export default {
  name: "AdModal",
  data () {
    return {
      publicPath: process.env.BASE_URL,
      enableSubmission: false
    }
  },
  props: ['playProp'],
  watch: { 
    playProp: function(newVal, oldVal) {
      if (newVal === true) {
        this.play();
      } else {
        this.enableSubmission = false;
      }
    }
  },  
  methods: {
    close() {
      this.$emit("close");
    },
    submitScoreCard() {
      this.$emit("submitScoreCard");
    },
    adModalToggled() {
      //alert('adModalToggled');
    },
    onEnd: function () {
      this.enableSubmission = true;
      this.$emit("submitScoreCard");
    },
    play: function() {
      var video = document.getElementById("ad_video");
      video.play();

      //failsafe
      var self = this;
      setTimeout(function() {
        self.enableSubmission = true;
      }, 10000);
    }
  },
  mounted(){
  }
};
</script>
